/** Data attributes scope for Spotlight components */
export const SCOPE = 'lumx-spotlight';

/** Minimum query length to trigger search */
export const MIN_QUERY_LENGTH = 2;

/** cache id to handle nav scroll on click */
export const BO_SIDE_NAV_CACHE_SCROLL_ID = 'back-office-side-nav-scroll';

/** localStorage key for the last visited items */
export const SPOTLIGHT_LAST_VISITED_CACHE_KEY = 'spotlight-last-visited';

/** Maximum number of last visited items to store */
export const MAX_LAST_VISITED_ITEMS = 5;

export enum SPOTLIGHT_FILTER {
    ALL = 'all',
    PAGE = 'page',
    TEXT = 'text',
}
